import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';
import Tooltip from '../../../../../components/common/Tooltip';
import Typography from '../../../../../components/common/Typography';
import { ROUTE_GOVCRM_CONTACTS } from '../../../../../constants/routes';
import { CRM_TAB_KEYS } from '../../../../GovCrm/Contacts/helpers';
import { useTrans } from '../../../../../services/i18n';
import styles from './CrmOrganizationIndicator.module.css';

const LABEL_KEY = 'in-crm';

const CrmOrganizationIndicator = ({ crmCompanyId }) => {
  const history = useHistory();
  const { trans } = useTrans();
  const crmAccessEnabled = useSelector((state) => state.orgSettings.crmAccessEnabled === true);

  const label = trans(LABEL_KEY);

  const navigateToCrmOrganization = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (!crmCompanyId) return;

      history.push({
        pathname: ROUTE_GOVCRM_CONTACTS.path,
        state: {
          crmTab: CRM_TAB_KEYS.ORGANIZATIONS,
          companyId: crmCompanyId,
        },
      });
    },
    [crmCompanyId, history]
  );

  if (!crmAccessEnabled || !crmCompanyId) return null;

  const href = ROUTE_GOVCRM_CONTACTS.path;

  const control = (
    <a className={styles.iconButton} href={href} aria-label={label} onClick={navigateToCrmOrganization}>
      <BusinessOutlinedIcon style={{ fontSize: 18 }} />
    </a>
  );

  return (
    <Tooltip placement="top" RefComponent="span" title={<Typography variant="body2">{label}</Typography>}>
      <span className={styles.tooltipAnchor}>{control}</span>
    </Tooltip>
  );
};

CrmOrganizationIndicator.propTypes = {
  crmCompanyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default CrmOrganizationIndicator;
